import { useGT } from 'gt-react';
import { LeadTimeOverridePanel } from '../suppliers/LeadTimeOverridePanel';
import { bulkLeadTimeSeriesTargets } from '../utils/assignmentBulkEditSession';
import { assignmentLineHighlightSession } from '../utils/assignmentLineHighlightSession';

export function LeadTimeDetailOverrideBlock({
  warehouseId,
  productV3Key,
  suggestionId,
  highlightCartKey,
}: {
  warehouseId: string;
  productV3Key: string;
  suggestionId: string | null;
  highlightCartKey: string | null;
}) {
  const gt = useGT();
  const bulkLeadTime =
    suggestionId != null && highlightCartKey != null
      ? bulkLeadTimeSeriesTargets(
          assignmentLineHighlightSession(highlightCartKey),
          suggestionId,
        )
      : null;

  return (
    <div className="border-t border-gray-200 pt-4">
      {bulkLeadTime != null && bulkLeadTime.highlightedLineCount > 1 ? (
        <p className="mb-2 text-xs font-medium text-sky-800">
          {gt(
            '{n} lines selected on the board — this override applies to each distinct item×warehouse in that selection.',
            {
              context: 'lead time bulk highlight banner',
              n: bulkLeadTime.highlightedLineCount,
            },
          )}
        </p>
      ) : null}
      <LeadTimeOverridePanel
        warehouseId={warehouseId}
        productV3Key={productV3Key}
        bulkLeadTime={
          bulkLeadTime != null && bulkLeadTime.highlightedLineCount > 1
            ? bulkLeadTime
            : undefined
        }
      />
    </div>
  );
}
